
// 3개 모달리티 불량 점수 (0~1, 1에 가까울수록 불량 신호 강함)
// Sv=비전, Sp=공정, St=온도
export const modalityScores = {
  vision: 0.72,   // Sᵥ
  process: 0.48,  // Sₚ
  thermal: 0.81,  // Sₜ (온도민감 불량 신호 강함)
};

// 모달리티별 자체 정상/불량 판정 임계값 (score >= threshold → 불량)
export const modalityThreshold = 0.5;

// 모달리티별 판정 결과 헬퍼 (정상 'OK' / 불량 'NG')
export const judgeModality = (score) => (score >= modalityThreshold ? 'NG' : 'OK');

// 판정 배지 메타 (모달리티 개별 판정용)
export const modalityJudgeMeta = {
  OK: { labelKey: 'pages.moduleb.common.judgeOk', color: '#22c55e', bg: 'rgba(34,197,94,0.12)' },
  NG: { labelKey: 'pages.moduleb.common.resultNg', color: '#ef4444', bg: 'rgba(239,68,68,0.12)' },
};

// 기본 가중치 (합 = 1)
export const defaultWeights = {
  alpha: 0.35, // α (비전)
  beta: 0.35,  // β (공정)
  gamma: 0.30, // γ (온도, 신규)
};

// 판정 임계값
export const fusionThreshold = 0.5;

// 모달리티 메타 (라벨/색상/기호)
export const modalityMeta = {
  vision: { labelKey: 'pages.moduleb.common.sources.vision', symbol: 'Sᵥ', weightKey: 'alpha', weightSymbol: 'α', color: '#22c55e' },
  process: { labelKey: 'pages.moduleb.common.sources.process', symbol: 'Sₚ', weightKey: 'beta', weightSymbol: 'β', color: '#3B82F6' },
  thermal: { labelKey: 'pages.moduleb.common.sources.temperature', symbol: 'Sₜ', weightKey: 'gamma', weightSymbol: 'γ', color: '#f97316' },
};

// Graceful Degradation 시나리오 설명 (온도 결측 시)
export const degradationInfo = {
  noteKey: 'pages.moduleb.fusion.degradationNote',
};
